module.exports = __webpack_public_path__ + "media/mutter_1.0.d75f11a6.mp4";